import type { TicketCategoryNode } from '@gb-ticket/shared-types';

export function flattenCategories(
  nodes: TicketCategoryNode[],
  prefix = '',
): { id: string; label: string }[] {
  const items: { id: string; label: string }[] = [];
  for (const node of nodes) {
    const path = prefix ? `${prefix} / ${node.name}` : node.name;
    const label = node.isActive ? path : `${path} (inaktiv)`;
    items.push({ id: node.id, label });
    if (node.children.length > 0) {
      items.push(...flattenCategories(node.children, path));
    }
  }
  return items;
}

export function leafCategories(
  nodes: TicketCategoryNode[],
): { id: string; name: string; group: string | null }[] {
  const leaves: { id: string; name: string; group: string | null }[] = [];
  for (const node of nodes) {
    if (!node.isActive) {
      continue;
    }
    if (node.children.length === 0) {
      leaves.push({ id: node.id, name: node.name, group: null });
      continue;
    }
    for (const child of node.children) {
      if (child.isActive && child.children.length === 0) {
        leaves.push({ id: child.id, name: child.name, group: node.name });
      }
    }
  }
  return leaves;
}
